type RemoveOrganizationalUnitError = {
  notFound: boolean;
};

const removeOrganizationalUnitError: RemoveOrganizationalUnitError = {
  notFound: false,
};

export type { RemoveOrganizationalUnitError };

export { removeOrganizationalUnitError };
